import { FC } from 'react'

import { TextareaInput } from 'ui/components/InputV2'
import { Select } from 'ui/components/Select'
import { Col, Col2x, FormRow } from 'ui/themes/globalStyles'

import * as SC from '../../style'
import { ReviewTheInternationalACHReportWasThereProps } from './ReviewTheInternationalACHReportWasThereProps'

export const ReviewTheInternationalACHReportWasThere: FC<ReviewTheInternationalACHReportWasThereProps> = ({
  Field
}) => (
  <>
    <FormRow>
      <Col2x>
        <SC.SecondText>
          Review the ACH activity for international transactions and unknown merchant/vendor activity.
        </SC.SecondText>
      </Col2x>
    </FormRow>
    <FormRow>
      <Col>
        <Field
          name="reviewTheInternationalACHReportWasThere"
          label="Was there international or unknown merchant/vendor activity?"
          input={Select}
          inputProps={{
            data: [
              {
                label: 'Yes – See comments',
                value: 'yes'
              },
              {
                label: 'All Transactions Ok',
                value: 'all_transactions'
              },
              {
                label: 'No Transactions of this Type',
                value: 'no_transactions'
              }
            ]
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col>
        <Field
          name="reviewTheInternationalACHReportActivityAddressed"
          label=" If noted, how was the activity addressed?"
          input={Select}
          inputProps={{
            data: [
              {
                label: 'N/A',
                value: 'n/a'
              },
              {
                label: 'Transaction cleared with communication to customer during review',
                value: 'cleared'
              },
              {
                label: 'Transaction added to annual questions',
                value: 'added'
              }
            ]
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col2x>
        <Field
          name="reviewTheInternationalACHReportComments"
          label="Comments"
          input={TextareaInput}
          inputProps={{
            maxLength: 5000
          }}
        />
      </Col2x>
    </FormRow>
  </>
)
